export class IdModel {
  id: number
  constructor(id?) {
    this.id = id
  }
}
